import { SpokeDeliveryStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { queryOptions, skipToken } from '@tanstack/react-query'

import { TimelineFilterValues } from '../StayTimeline.types'
import { getTimelineConversation } from '../stores/api/stayTimelineArriere'
import { isStayTimelineLive } from '../stores/api/stayTimelineLiveArriere'
import { stayTimelineQueryKeys } from './queryKeys'

type TimelineConversation = Awaited<ReturnType<typeof getTimelineConversation>>

interface GetTimelineConversationQueryOptionsParams {
  filters: Pick<TimelineFilterValues, 'sends'>
  bookingId?: string
  enabled?: boolean
}

const SENDS_FILTER_ARGS = {
  hide: { includeSends: false, includeSendsToAdditionalGuests: false },
  mainGuest: { includeSends: true, includeSendsToAdditionalGuests: false },
  all: { includeSends: true, includeSendsToAdditionalGuests: true },
} as const

export const getTimelineConversationQueryOptions = ({
  bookingId,
  filters,
  enabled = true,
}: GetTimelineConversationQueryOptionsParams) => {
  const args = SENDS_FILTER_ARGS[filters.sends]

  return queryOptions({
    refetchIntervalInBackground: true,
    queryKey: stayTimelineQueryKeys.timelineConversation({ bookingId, args }),
    queryFn:
      bookingId && !!enabled
        ? () => getTimelineConversation({ bookingId: bookingId!, ...args })
        : skipToken,
    refetchInterval: query => getRefetchInterval({ bookingId, conversation: query.state.data }),
  })
}

interface GetRefetchIntervalParams {
  bookingId?: string
  conversation?: TimelineConversation
}

// A live subscription signals every timeline change, so polling is only the fallback without one
const getRefetchInterval = ({ bookingId, conversation }: GetRefetchIntervalParams) => {
  if (isStayTimelineLive(bookingId)) return false

  const hasPendingDelivery = !!conversation?.timeline.some(
    event => event.deliveryStatus === SpokeDeliveryStatus.pending,
  )

  return hasPendingDelivery ? 10_000 : 60_000
}
